module.exports = __webpack_public_path__ + "img/svg/no-competitions.93ff802034c53043f7fe268a8b3637e2.svg";